var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatFace2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chat-face2_svg__a",
    d: "M0 0h13.5v7.875H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ac1e1e",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "chat-face2_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chat-face2_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.256 7.875a1.243 1.243 0 01-1.243-1.243V1.244a1.243 1.243 0 112.487 0v5.388c0 .687-.557 1.243-1.244 1.243m-11.013 0A1.243 1.243 0 010 6.632V1.244a1.243 1.243 0 112.487 0v5.388c0 .687-.557 1.243-1.244 1.243",
    fill: "#FFF",
    mask: "url(#chat-face2_svg__b)"
  })))));
}
export default SvgChatFace2;